import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import Footer from './Footer';
import 'normalize.css';
import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import Header from './Header';

const ContainerStyles = styled.div`
    max-width: var(--container);
    background-color: rgba(255, 255, 255, 0.85);
    margin: 0 auto;
    padding: 3rem 1.5rem;
    min-height: calc(100vh - 2rem);
    @media (max-width: 650px) {
        padding: 8.5rem 1.5rem;
    }
`;

export default function Layout({ children }) {
    const { siteBgImage } = useStaticQuery(graphql`
        query {
            siteBgImage: sanityStoreSettings {
                siteBgImage {
                    asset {
                        url
                    }
                }
            }
        }
    `)
    return (
        <>
            <GlobalStyles siteBgImage={siteBgImage.siteBgImage.asset.url} />
            <Typography />
            <Header />
                <ContainerStyles>
                    {children}
                </ContainerStyles>
            <Footer />
        </>
    )
}